export default "__VITE_ASSET__DuZ0$QrD__"